// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2YtNm","content":"LoadingAlert_content__27cwA"};